export default function useTranslation() {
  const { locale } = useI18n()

  const formatDocumentWithoutLocalePrefix = (params: {
    document: Pick<ParsedContent, string>
    fields: string[]
  }) => {
    // Format response and remove locale suffix
    const formatted: { [key: string]: any } = {}

    for (const field of params.fields) {
      if (!params.document[field] || !field.includes(`-${locale.value}`)) {
        formatted[field] = params.document[field]
      }
      else {
        formatted[field.replace(`-${locale.value}`, '')] = params.document[field]
      }
    }

    return formatted
  }

  const formatFieldsWithLocalePrefix = (fields: string[]) => {
    return fields.map((field) => {
      const i18nFields = ['banner', 'body']

      if (!field.includes(`-${locale.value}`) && !i18nFields.includes(field)) {
        return `${field}-${locale.value}`
      }

      return field
    })
  }

  const fetchTranslatedDocument = async (params: {
    document: string
    fields?: string[]
    key: string
  }) => {
    return await useAsyncData(params.key, async () => {
      // Format specific fields with the locale version
      if (params.fields?.length) {
        params.fields = formatFieldsWithLocalePrefix(params.fields)
      }

      return await queryContent(params.document)
        .only(params.fields || [])
        .findOne()
        .then((document) => {
          if (!params.fields) {
            return document
          }

          return formatDocumentWithoutLocalePrefix({
            document,
            fields: params.fields!,
          })
        }) as ParsedContent | undefined
    })
  }

  const fetchTranslatedDocuments = async (params: {
    fields?: string[]
    folder?: string
    key: string
  }) => {
    return await useAsyncData(params.key, async () => {
      // Format specific fields with the locale version
      if (params.fields?.length) {
        params.fields = formatFieldsWithLocalePrefix(params.fields)
      }

      return await queryContent(params.folder || '/')
        .only(params.fields || [])
        .find()
        .then((documents) => {
          if (!params.fields) {
            return documents
          }

          return documents.map((document) => {
            return formatDocumentWithoutLocalePrefix({
              document,
              fields: params.fields!,
            })
          })
        }) as ParsedContent[]
    })
  }

  return {
    fetchTranslatedDocument,
    fetchTranslatedDocuments,
  }
}
